module.exports = __webpack_public_path__ + "static/mid-fd2916f5b7915fbe59d1a70ba50f1d69.png";